import Vue from "vue";
import VueRouter from "vue-router";
import LandingPage from "@/components/LandingPage";
import Contact from "@/components/Contact";
import Pricing from "@/components/Pricing";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "LandingPage",
    component: LandingPage,
  },
  {
    path: "/about",
    name: "AboutView",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/pricing",
    name: "Pricing",
    component: Pricing,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
